export const selectCoachHost = ({ hosts }) => {
  return (hosts || []).find((h) => h.isOfficialCoach) || hosts?.[0];
};

export const selectCoachLabel = (user) =>
  `${user.isOfficialCoach ? 'Coach' : 'Host'} ${user.displayName}`;

export const selectDeepLinkAttrs = ({ id: gameId } = {}) =>
  gameId
    ? {
        gameId,
        screen: 'game_profile',
        utm_source: 'invite',
      }
    : {};
